import { useQuery } from 'react-query';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { requests } from 'RestAPIs/rapini';
import { showSnackbar } from 'components/shared';

import { EventResponse, PlanningEntityIdentifier } from 'generated/index';

export type UseFilteredAppointmentsParams = {
  startDate: string;
  endDate: string;
  planningEntity?: PlanningEntityIdentifier;
};

export const useFilteredAppointments = ({
  startDate,
  endDate,
  planningEntity
}: UseFilteredAppointmentsParams) => {
  const { t } = useTranslation('common');

  return useQuery<EventResponse[]>(
    [
      'appointmentsOverview',
      startDate,
      endDate,
      planningEntity?.entityId,
      planningEntity?.planningEntityType
    ],
    async () => {
      if (!planningEntity || !startDate || !endDate) return [];

      return await requests.getAppointmentFiltered({
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        planningEntityIdentifiers: [planningEntity]
      });
    },
    {
      enabled: !!planningEntity && !!startDate && !!endDate,
      onError: () => {
        showSnackbar({
          severity: 'error',
          message: t('somethingWentWrong')
        });
      },
      refetchOnWindowFocus: false
    }
  );
};
